// Produces the slug used in shared-run URLs (/ai/3d-models/<slug>-<runId>).
//
// The output is paired with parseRunIdFromPathname in
// Pods/ThreeDStudio/Hooks. Changes here that alter the produced slug must
// keep round-tripping via parseRunIdFromPathname(buildSharedRunPathname(...)).
//
// Falls back to "model" when the title is empty so the URL always has a
// non-empty slug segment before the trailing -<id>.
const slugifyTitle = (title) => {
  if (!title) {
    return 'model'
  }
  const slug = title
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || 'model'
}

export default slugifyTitle
